module.exports = __webpack_public_path__ + "static/media/imagem24.7e425c67.jpeg";